import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatGridListModule } from '@angular/material/grid-list';
import { NvMatTooltipModule } from '../../shared/components/nv-mat-tooltip/nv-mat-tooltip.module';
import { ContentToolsModule } from '../../shell/content-tools/content-tools.module';
import { GraphDetailContentModule } from './graph-detail-content/graph-detail-content.module';
import { GraphDetailComponent } from './graph-detail.component';
import { GraphDetailService } from './graph-detail.service';

@NgModule({
  declarations: [GraphDetailComponent],
  imports: [
    GraphDetailContentModule,
    CommonModule,
    NvMatTooltipModule,
    ContentToolsModule,
    MatMenuModule,
    MatExpansionModule,
    MatSelectModule,
    MatGridListModule,
  ],
  providers: [GraphDetailService],
})
export class GraphDetailModule {}
